// Local formatting helpers for the AP Purchase Invoice plug-in.

const PKR_FORMATTER = new Intl.NumberFormat('en-PK', {
  style: 'currency',
  currency: 'PKR',
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});

export function formatPKR(value: unknown): string {
  if (value === null || value === undefined || value === '') return '—';
  const n = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(n)) return '—';
  return PKR_FORMATTER.format(n);
}

const MONTHS = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];

export function formatDate(value: unknown): string {
  if (!value) return '—';
  const s = String(value);
  // Accept either YYYY-MM-DD or full ISO timestamp.
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
  if (!m) return s;
  const year = m[1];
  const month = MONTHS[Number(m[2]) - 1] ?? m[2];
  const day = String(Number(m[3]));
  return `${day.padStart(2, '0')} ${month} ${year}`;
}
